import { initUnsecureSalesforceBot, launchUnsecureSalesforceBot } from 'common/salesforce-bot';
import Wahanda from 'common/wahanda';
import { ChatSourceType } from 'src/tracking-container/events/chat';
import { SalesforceBotInitializer } from 'common/salesforce-bot/initializer';
import { SupportChatWidgetInitializer } from 'common/support-chat/initializer';

enum SupportChatType {
  SALESFORCE_CHAT_SDK_UNSECURE = 'salesforce-chat-unsecure',
  SALESFORCE_CHAT_SDK = 'salesforce-chat',
  CUSTOM_CHAT_WIDGET = 'custom-chat-widget',
  HELP_CENTER_REDIRECT = 'help-center-redirect',
}

/**
 * This method should be invoke to actually trigger the opening of the chat.
 * @param source the point from which the opening of the chat has been triggered
 */
export const openChat = async (source: ChatSourceType): Promise<void> => {
  const chatType = determineSupportChatType();
  try {
    switch (chatType) {
      case SupportChatType.SALESFORCE_CHAT_SDK_UNSECURE:
        return launchUnsecureSalesforceBot({ source });
      case SupportChatType.SALESFORCE_CHAT_SDK:
      case SupportChatType.CUSTOM_CHAT_WIDGET:
        App.trigger(Wahanda.Event.SALESFORCE_BOT_OPEN, { source });
        return Promise.resolve();
      default:
        openHelpCenter();
        break;
    }
  } catch (error) {
    Wahanda.ToastNotifications.sendMessage(error, { variant: 'danger', timeout: 10000 });
  }
};

const openHelpCenter = () => {
  const helpCenterUrl = 'https://partnercare.treatwell.com/s/?language=en_GB';
  window.open(helpCenterUrl, '_blank');
};

export const initSupportChat = (): void => {
  console.log('Initialising support chat...');
  try {
    const chatType = determineSupportChatType();
    switch (chatType) {
      case SupportChatType.SALESFORCE_CHAT_SDK_UNSECURE:
        initUnsecureSalesforceBot();
        break;
      case SupportChatType.SALESFORCE_CHAT_SDK:
        SalesforceBotInitializer().render();
        break;
      case SupportChatType.CUSTOM_CHAT_WIDGET:
        SupportChatWidgetInitializer().render();
        break;
      default:
        break;
    }
  } catch (e) {
    console.error('Error during support chat initialization', e);
  }
};

const determineSupportChatType = (): SupportChatType => {
  if (!Wahanda.Features.isEnabled('CD-823-salesforce-bot')) {
    return SupportChatType.HELP_CENTER_REDIRECT;
  }

  if (Wahanda.Features.isEnabled('CRM-3913-custom-support-chat-enabled')) {
    return SupportChatType.CUSTOM_CHAT_WIDGET;
  }

  if (
    Wahanda.Features.isEnabled('CD-1312-salesforce-bot-secure-authentication') &&
    !App.isMasquerading()
  ) {
    return SupportChatType.SALESFORCE_CHAT_SDK;
  }

  return SupportChatType.SALESFORCE_CHAT_SDK_UNSECURE;
};
